export default function TextCell({
    value,
    alignment,
}: {
    value: string,
    alignment: 'left' | 'center',
}) {
    return (
        <div className={`flex ${alignment === 'left' ? 'justify-start' : 'justify-center'} items-center gap-2 py-4 px-6`}>
            <p className="text-[14px] font-medium text-default max-w-[400px] text-center">
                {value}
            </p>
        </div>
    )
}